import React,{Fragment,useState,useEffect,useContext} from 'react';
import App from './App';
import { apiDataUIUrl,thisMock } from './projConst';
import mockUIapp from './api/mockUIapp';
import * as api from './api/apiFunc'
import * as R from 'ramda'
import { useQueryParam, NumberParam, StringParam } from 'use-query-params';
import { shallowEqual, useDispatch,useSelector } from 'react-redux'
import { DataServerContext } from "./Server/DataServerContext";
import {UiGlobalcss,UiThemecss,UiConfigApp} from './Actions/actions.jsx'

function Main() {
  const [db, setDb] = useQueryParam('db', StringParam);
  const [tree, setTree] = useQueryParam('tree', NumberParam);
  const [argum, setArg] = useQueryParam('argum', StringParam);

  const { getServerDataRedux, } = useContext(DataServerContext);

  const dispatch = useDispatch();

  const appParams = { tree, db };
  const mainuniui = useSelector(state=>state.mainuniui,shallowEqual)
   
  useEffect(async () => {
    dispatch(getServerDataRedux(apiDataUIUrl,false, {appParams},true, mockUIapp,'FETCH_UNIVER_UI'))
  }, []);
  useEffect(() => {
    if (api.isEmpty(mainuniui)) return
    let header = R.find(R.propEq("block", "header"))(mainuniui.serverdata.blocks) 
    let menu = R.find(R.propEq("block", "toolsbar"))(mainuniui.serverdata.blocks) 
    dispatch(UiGlobalcss(api.parsingCss(mainuniui.serverdata.blocks, '', 'css', 'children')))
    dispatch(UiThemecss(mainuniui.serverdata.theme))
    dispatch(UiConfigApp({ ...mainuniui.serverdata,header,menu }))
  }, [mainuniui]);

  return (
    <Fragment>
      {mainuniui && mainuniui.globalCss && 
         <App tree={tree} db={db} argum={argum} ldb={null} iconsApp={mainuniui.iconsApp} configApp={mainuniui.blocks} themeCss={mainuniui.themeCss} globalCss={mainuniui.globalCss}/>
        /*  userdata={userdata}
          maindata={otherdata}
          SaveDict={handleSaveDict}
          SaveReq={handleSaveReq}
      */}
     </Fragment> 
  );
}

export default Main;
